<template>
 <!-- :style="[bottomStyle, topStyle, {top:(top +'px')}]" -->
  <div class="jy-pageBody" :class="[customClass, { 'is-footer': $scopedSlots.footer }]">
    <slot></slot>
    <div v-if="$scopedSlots.footer" class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate/velocity.min';
import Emitter from '../../utils/emitter';
import { hasClass, addClass, removeClass } from 'element-ui/src/utils/dom';
export default {
  name: 'JyPagebody',
  componentName: 'JyPagebody',
  mixins: [Emitter],
  props: {
    customClass: String,
    isPagefooter: Boolean,
    activatedLoad: Function
  },
  data() {
    return {top:0, bottom:0, ptop:0, scrollTop:0, bodyStyle:{}}
  },
  computed: {
    topStyle() {
      return {'padding-top': `calc(${this.top ? this.ptop : 0}px + ${this.$store.state.isSm ? 0.5 : 1}rem)`};
    },
    bottomStyle() {
      return this.bottom ? {bottom: this.bottom +'px'} : '';
    }
  },
  created () {
    this.$on('jy.slide.show', () => {
      Velocity(
        this.$el,
        {left: '14rem'}
      );

      this.$nextTick(() => {
        this.$emit('resize', this.$el.offsetWidth);
      });
    });
    this.$on('jy.slide.hide', () => {
      Velocity(
        this.$el,
        {left: '2.3rem'}
      );

      this.$nextTick(() => {
        this.$emit('resize', this.$el.offsetWidth);
      });
    });
  },
  mounted () {
    this.$nextTick(() => {
      this.handelResize();

      // init left
      //let slide = document.getElementById('jy-sidenav-col');
      //this.$el.style.left = (slide ? slide.clientWidth : 0) +'px';
      this.bodyStyle = this.$el.currentStyle ? this.$el.currentStyle : window.getComputedStyle(this.$el, null);

      if (this.isPagefooter) {
        let fh = 0;
        let footer = this.$parent.$refs.footer;
        setTimeout(() => {
          footer &&
            (fh = footer.$el.offsetHeight);
  
          fh && (this.bottom = fh);
        }, 100);
      }
    });

    // set history scroll
    let scrollId;
    this.$el.addEventListener('scroll', () => {
      clearTimeout(scrollId);
      scrollId = setTimeout(this.handleScroll, 300);
    });
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.handelResize, 300);
    });
    // set current page scrollTop
    let activatedId;
    this.$on('jy-activated', () => {
      clearTimeout(activatedId);
      activatedId = setTimeout(() => {
        // console.log('jy-activated...')
        this.$el.scrollTop = this.scrollTop;
        this.setTop();
        //
        if (this.activatedLoad && this.activatedLoad instanceof Function) {
          this.activatedLoad();
        }
      }, 15);
    });
  },
  beforeDestroy () {
    this.$el && this.$el.removeEventListener('scroll', this.handleScroll);
    this.handelResize && window.removeEventListener('resize', this.handelResize);
  },
  methods: {
    handelResize() {
      let nav = window.document.getElementById('jy-breadcrumb');
      // , footer = window.document.getElementsByClassName('jy-pageFooter');
      if (nav) {
        this.ptop = nav.offsetHeight;
      }
      this.setTop();
      let isSm = window.document.body.offsetWidth < 1065;
      this.$store.state.isSm = isSm;
      if (isSm || (window.document.getElementById('jy-sidenav') && window.document.getElementById('jy-sidenav').offsetWidth < 50)) {
        this.$el.style.left = '2.3rem';
      }

      this.$nextTick(() => {
        this.$emit('resize', this.$el.offsetWidth);
      });
    },
    setTop() {
      let navbar = window.document.getElementById('jy-navbar-main');
      if (navbar) {
        this.top = 46.1;//navbar.offsetHeight;
      }
    },
    handleScroll() {
      this.scrollTop = this.$el.scrollTop;
      this.fixed(); // 钉住元素
      this.$emit('scroll', this.scrollTop, this);
    },
    fixed() {
      this.$el.querySelectorAll('.j-pin').forEach(d => {
        let oStyle = d.currentStyle ? d.currentStyle : window.getComputedStyle(d, null);
        // console.log(d.offsetTop +'--'+ this.scrollTop)
        if (d.offsetTop < (this.scrollTop - this.top + this.ptop) && window.document.body.offsetWidth > 1200) {
          oStyle.position === 'static' && this.doFixed(d);
        } else {
          this.doStatic(d);
        }
      });
    },
    doFixed(d) {
      let clone = d.previousSibling;
      if (clone && hasClass(clone, 'j-clone')) {
        clone.parentNode.removeChild(clone);
      }
      clone = d.cloneNode(true);
      removeClass(clone, 'j-pin');
      addClass(clone, 'j-clone');
      d.parentNode.insertBefore(clone, d);
      d.style.position = 'fixed';
      d.style.zIndex = 4;
      if (hasClass('pinsame')) {
        d.style.left = d.offsetLeft +'px';
        // d.style.width = oStyle.width;
        d.style.width = parseFloat(this.bodyStyle.width) - (parseFloat(this.bodyStyle.paddingLeft) * 2) +'px';
      } else {
        d.style.left = 0;
        d.style.right = 0;
      }
      d.style.top = (this.top + (this.ptop || 0)) +'px';
      addClass(d, 'pined');
    },
    doStatic(d) {
      let clone = d.previousSibling;
      if (clone && hasClass(clone, 'j-clone')) {
        clone.parentNode.removeChild(clone);
      }
      d.style.position = '';
      removeClass(d, 'pined');
    }
  }
}
</script>
<style lang="less" scoped>
.jy-pageBody{
  &.is-footer{padding-bottom:0;}
  .footer {
    display:flex;
    margin-top:1rem;
    padding:.5rem;
    align-items:center;
    justify-content:center;
    background-color:#fff;
  }
} 
</style>